import "./style.scss";

export const Footer = () => {
  return (
    <footer className="footer-container">
      <span>Todos os direitos reservados @ Norte SC Revestimentos 2024</span>
    </footer>
  );
};
